import { IMessageDeleteEvent } from 'APP/model/message/messageModel.types';
import Entities from 'STORE';

export async function handleDeleteMessage(data: IMessageDeleteEvent): Promise<void> {
  const group = Entities.GroupsStore.getGroupById(data.groupId);
  if (!group) {
    return;
  }

  group.messagesStore.removeMessageById(data.messageId);
}
